import Command from '@ckeditor/ckeditor5-core/src/command';
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';
import first from '@ckeditor/ckeditor5-utils/src/first';
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const { helperAttributes: { TRACK_CHANGES_EDITING }, PLUGINS: { TRACK_CHANGES },
  COMMANDS: { CMD_TRACK_CHANGES } } = CkeditorConstants;

export default class InsertAudioCommand extends Command {
  execute({ value }) {
    this.editor.fire('insertaudio');
    this.isEnabled = false;
    const isTrackChangesEnabled = this.editor.commands.get(CMD_TRACK_CHANGES).value && this.editor.plugins.get(TRACK_CHANGES).isEnabled;
    this.editor.model.change(writer => {
      const selection = this.editor.model.document.selection;
      const schema = this.editor.model.schema;
      const audioType = this.determineAudioTypeForInsertionAtSelection(schema, selection);
      let parentWrapper;
      if (audioType === 'audioInline') {
        const spanTag = writer.createElement('inlineaudio');
        parentWrapper = writer.createElement('audio', {
          'id': randomUUIDGenerator(),
          'class': 'ck-media-audio',
          'controls': 'test',
          'data-cke-ignore-events': 'true'
        });
        writer.append(parentWrapper, spanTag);
        writer.appendElement('source', {
          'src': value.audioContent[0].src,
          'resource': value.audioContent[0].resource,
          'typeof': value.audioContent[0].typeofnode,
          'data-node-name': value.audioContent[0].name,
          'title': value.audioContent[0].title,
          'data-tenant-id': value.audioContent[0].tenantId
        }, parentWrapper);
        this.editor.model.insertContent(
          spanTag,
          selection
        );
      }
      else {
        const figureTag = writer.createElement('figureTag', {
          'class': 'media-class',
        });
        parentWrapper = writer.createElement('audio', {
          'id': randomUUIDGenerator(),
          'class': 'ck-media-audio',
          'controls': 'test',
          'data-cke-ignore-events': 'true'
        });
        writer.append(parentWrapper, figureTag);
        writer.appendElement('source', {
          'src': value.audioContent[0].src,
          'resource': value.audioContent[0].resource,
          'typeof': value.audioContent[0].typeofnode,
          'data-node-name': value.audioContent[0].name,
          'title': value.audioContent[0].title,
          'data-tenant-id': value.audioContent[0].tenantId
        }, parentWrapper);
        writer.insert(figureTag, selection.getFirstPosition());
        if (isTrackChangesEnabled) {
          const range = writer.createRangeOn(figureTag);
          this.editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(range);
        }
      }
    });
    this.editor.focus();
  }

  determineAudioTypeForInsertionAtSelection(schema, selection) {
    const firstBlock = first(selection.getSelectedBlocks());

    // Insert a block audio if the selection is not in/on block elements or it's on a block widget.
    if (!firstBlock || schema.isObject(firstBlock)) {
      return 'audioBlock';
    }

    // A block audio should also be inserted into an empty block element
    // (that is not an empty list item so the list won't get split).
    if (firstBlock.isEmpty && firstBlock.name != 'listItem') {
      return 'audioBlock';
    }

    if (firstBlock._children._nodes[0].name === 'figureTag') {
      return 'audioBlock';
    }

    // Otherwise insert an inline audio.
    return 'audioInline';
  }
}
